import { useMemo, type ReactNode } from 'react';
import { getLocalizationService } from '../bootstrap';
import type { ILocalizationService } from '../types';
import { LocalizationContext } from './localizationContext';

export function LocalizationProvider({
  children,
  service,
}: {
  children: ReactNode;
  service?: ILocalizationService;
}) {
  const value = useMemo(
    () => service ?? getLocalizationService(),
    [service],
  );

  return (
    <LocalizationContext.Provider value={value}>{children}</LocalizationContext.Provider>
  );
}
